import SmartSearch from './SmartSearch.vue';

export default SmartSearch;
